import { supabase } from '../lib/supabase';

export const integrationService = {
  async getAll() {
    const { data: { user } } = await supabase?.auth?.getUser();
    if (!user) throw new Error('Not authenticated');

    const { data, error } = await supabase?.from('social_integrations')?.select('*')?.eq('user_id', user?.id)?.order('platform', { ascending: true });

    if (error) throw error;

    return data?.map(row => ({
      id: row?.id,
      userId: row?.user_id,
      platform: row?.platform,
      status: row?.status,
      platformUsername: row?.platform_username,
      platformUserId: row?.platform_user_id,
      connectedAt: row?.connected_at,
      lastSyncedAt: row?.last_synced_at,
      createdAt: row?.created_at,
      updatedAt: row?.updated_at
    }));
  },

  async updateStatus(integrationId, status, platformUsername = '') {
    const { data: { user } } = await supabase?.auth?.getUser();
    if (!user) throw new Error('Not authenticated');

    const updates = {
      status,
      platform_username: platformUsername,
      connected_at: status === 'connected' ? new Date()?.toISOString() : null
    };

    const { data, error } = await supabase?.from('social_integrations')?.update(updates)?.eq('id', integrationId)?.eq('user_id', user?.id)?.select()?.single();

    if (error) throw error;

    return {
      id: data?.id,
      userId: data?.user_id,
      platform: data?.platform,
      status: data?.status,
      platformUsername: data?.platform_username,
      connectedAt: data?.connected_at,
      updatedAt: data?.updated_at
    };
  },

  async disconnect(integrationId) {
    return this.updateStatus(integrationId, 'disconnected', '');
  },

  async connect(integrationId, platformUsername) {
    return this.updateStatus(integrationId, 'connected', platformUsername);
  }
};